var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.passwordUpdated
    ? _c(
        "div",
        [
          _c("p", [_vm._v(_vm._s(_vm.$t("account.password-update.success")))]),
          _vm._v(" "),
          _c("base-button", { on: { click: _vm.goLogin } }, [
            _vm._v(_vm._s(_vm.$t("account.password-update.click-login")))
          ])
        ],
        1
      )
    : _c(
        "b-form",
        {
          on: {
            submit: function($event) {
              $event.stopPropagation()
              $event.preventDefault()
              return _vm.updatePassword.apply(null, arguments)
            }
          }
        },
        [
          _vm.form.state.submitted && _vm.form.state.errors
            ? _c("b-alert", {
                attrs: { show: "", variant: "danger" },
                domProps: { innerHTML: _vm._s(_vm.submitError) }
              })
            : _vm._e(),
          _vm._v(" "),
          _c("p", [
            _vm._v(
              _vm._s(_vm.$t("account.password-update.security-requirements"))
            )
          ]),
          _vm._v(" "),
          _c(
            "b-form-group",
            [
              _c(
                "base-input",
                {
                  attrs: {
                    state: _vm.validateState("password"),
                    validator: _vm.$v.form.password,
                    placeholder: _vm.$t("account.password-update.password"),
                    type: _vm.showPassword ? "text" : "password"
                  },
                  model: {
                    value: _vm.$v.form.password.$model,
                    callback: function($$v) {
                      _vm.$set(_vm.$v.form.password, "$model", $$v)
                    },
                    expression: "$v.form.password.$model"
                  }
                },
                [
                  _c("template", { slot: "append" }, [
                    _c(
                      "span",
                      {
                        staticClass: "clickable",
                        on: {
                          click: function($event) {
                            _vm.showPassword = !_vm.showPassword
                          }
                        }
                      },
                      [
                        _c(
                          "i",
                          [
                            !_vm.showPassword
                              ? _c("b-icon-eye")
                              : _c("b-icon-eye-slash")
                          ],
                          1
                        )
                      ]
                    )
                  ])
                ],
                2
              ),
              _vm._v(" "),
              _c(
                "base-input",
                {
                  attrs: {
                    state: _vm.validateState("confirmedPassword"),
                    validator: _vm.$v.form.confirmedPassword,
                    placeholder: _vm.$t(
                      "account.password-update.repeat-password"
                    ),
                    type: _vm.showPassword ? "text" : "password"
                  },
                  model: {
                    value: _vm.$v.form.confirmedPassword.$model,
                    callback: function($$v) {
                      _vm.$set(_vm.$v.form.confirmedPassword, "$model", $$v)
                    },
                    expression: "$v.form.confirmedPassword.$model"
                  }
                },
                [
                  _c("template", { slot: "append" }, [
                    _c(
                      "span",
                      {
                        staticClass: "clickable",
                        on: {
                          click: function($event) {
                            _vm.showPassword = !_vm.showPassword
                          }
                        }
                      },
                      [
                        _c(
                          "i",
                          [
                            !_vm.showPassword
                              ? _c("b-icon-eye")
                              : _c("b-icon-eye-slash")
                          ],
                          1
                        )
                      ]
                    )
                  ])
                ],
                2
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-button",
            {
              staticStyle: { width: "100%" },
              attrs: { type: "submit", variant: "primary" }
            },
            [
              _vm._v(
                "\n    " +
                  _vm._s(_vm.$t("account.password-update.update-password")) +
                  "\n  "
              )
            ]
          ),
          _vm._v(" "),
          _c("hr")
        ],
        1
      )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-90c25652", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-90c25652","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/account/PasswordUpdate.vue
// module id = 4180
// module chunks = 55